import React, { FC } from 'react';
import DefaultFileLink from 'components/CampanhasMkt-components/CampanhasDefaultFileLink/defaultFileLink';
import { CampaignAudience, CampaignHelpModalProps } from 'models/campaign-mkt';
import ExcelImage from 'assets/img/campanhas-de-marketing/nova-campanha/image-excel.svg';
import { campaignAudienceHelp } from './static-content';
import * as S from './style';

const CampaignHelpModal: FC<CampaignHelpModalProps> = ({
  audience,
  mode,
  onClose,
  show,
}) => {
  const audienceContent = audience
    ? campaignAudienceHelp[audience as CampaignAudience]
    : undefined;

  if (mode === 'audience' && !audienceContent) return null;

  const title =
    mode === 'upload'
      ? 'Instruções para o envio do arquivo'
      : audienceContent?.title;

  return (
    <>
      <S.BackdropStyles />
      <S.ModalStyled
        aria-labelledby="campaign-help-modal-title"
        backdrop
        backdropClassName="campaign-help-backdrop"
        centered
        dialogClassName="campaign-help-modal"
        onHide={onClose}
        show={show}
      >
        <S.Header>
          <S.Title id="campaign-help-modal-title">{title}</S.Title>
          <S.CloseButton
            aria-label="Fechar modal"
            onClick={onClose}
            type="button"
          >
            <S.CloseIcon />
          </S.CloseButton>
        </S.Header>

        <S.Body>
          {mode === 'audience' && audienceContent ? (
            <S.Sections $compact={audienceContent.title === 'Calouros'}>
              {audienceContent.sections.map((section) => (
                <S.Section key={section.title}>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={`${section.title}-${paragraph}`}>{paragraph}</p>
                  ))}
                </S.Section>
              ))}
            </S.Sections>
          ) : (
            <S.Instructions>
              <S.InstructionIntro>
                <DefaultFileLink onModal>
                  Baixe a planilha modelo
                </DefaultFileLink>
                {
                  ' para preencher os contatos da campanha. O arquivo pode ser aberto e editado no Excel, Google Sheets ou em outra ferramenta de planilhas.'
                }
              </S.InstructionIntro>

              <p>Para garantir o envio correto:</p>
              <S.InstructionList>
                <li>
                  Mantenha as colunas da planilha modelo, sem renomear ou
                  remover campos;
                </li>
                <li>Preencha uma linha para cada contato;</li>
                <li>Os campos obrigatórios são: Nome, E-mail e Telefone;</li>
                <li>
                  O telefone deve conter DDD. Ex.: (12) 91234-1234 ou
                  12912341234;
                </li>
                <li>Cada campanha permite o envio de até 1.000 contatos;</li>
                <li>O arquivo deve ser enviado em formato .xlsx ou .csv.</li>
              </S.InstructionList>

              <S.ExampleLabel>Exemplo de preenchimento:</S.ExampleLabel>
              <S.SpreadsheetImage
                alt="Exemplo de preenchimento da planilha"
                loading="eager"
                src={ExcelImage}
              />
            </S.Instructions>
          )}
        </S.Body>

        <S.Footer>
          <S.ConfirmButton onClick={onClose} type="button">
            Entendi
          </S.ConfirmButton>
        </S.Footer>
      </S.ModalStyled>
    </>
  );
};

export default CampaignHelpModal;
